import {
  CheckboxValidation,
  IconSetType,
  IconSetsValidation,
} from '../../types';
import { getIconValuesFromCategory } from './iconHelpers';

export const isValidCheckboxValue = (
  rule: CheckboxValidation,
  cellValue: string
) => {
  const { useCustomCellValues, checkedValue, uncheckedValue } = rule;
  const checkedString = useCustomCellValues ? checkedValue : 'TRUE';
  const uncheckedString = useCustomCellValues ? uncheckedValue : 'FALSE';
  const isChecked = checkedString === cellValue;

  let isValid = true;
  if (!isChecked && cellValue.length) {
    isValid = !(cellValue !== checkedString && cellValue !== uncheckedString);
  }

  return {
    isValid,
    checkedString,
    uncheckedString,
    isChecked,
  };
};

export const isValidIconSetValue = (
  rule: IconSetsValidation,
  cellValue: string
) => {
  // TODO: Handle Custom icons
  const values = getIconValuesFromCategory(rule.category);

  if (!cellValue)
    return {
      isValid: true,
      nextValue: values[0]?.toString(),
    };

  // console.log(values, cellValue);

  switch (rule.setType) {
    case IconSetType.Multiple:
      return {
        isValid: isMultipleMatchesIcons(cellValue, values),
        nextValue: '',
      };
  }

  // console.log('value', values, cellValue, typeof cellValue);

  const index = values.findIndex((value) => value.toString() === cellValue);
  const nextValue = values[index + 1];
  return {
    isValid: index !== -1,
    nextValue: nextValue ? nextValue.toString() : '',
  };
};

const isMultipleMatchesIcons = (
  cellValue: string,
  values: Array<string | number>
) => {
  const numericCellValue = Number(cellValue);
  if (isNaN(numericCellValue)) return false;

  let isMatched = false;
  for (const value of values) {
    const numericIconValue = Number(value);
    if (isNaN(numericIconValue)) continue;
    const hasValue = (numericCellValue & numericIconValue) === numericIconValue;
    if (hasValue) {
      isMatched = true;
      break;
    }
  }

  return isMatched;
};
